import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-contentPromotionTypeShape",
  "use": "svg-icon-contentPromotionTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-contentPromotionTypeShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 8v6h4V8h2.51L8 2.99 3.49 8H6zm-5.498.331C-.078 8.975.38 10 1.245 10H4v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4h2.755c.865 0 1.322-1.025.743-1.669L8 0 .502 8.331z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol